export enum DROPDOWN1 {
  FIRST_TIER_SUBCONTRACTOR = "1st Tier Subcontractor",
  SECOND_TIER_SUBCONTRACTOR = "2nd Tier Subcontractor",
}

export enum DROPDOWN2 {
  OWNER = "Owner",
  GENERAL_CONTRACTOR = "General Contractor",
  SUBCONTRACTOR = "Subcontractor",
}

export enum DROPDOWN3 {
  RESIDENTIAL = "Residential",
  PRIVATE = "Private",
  PUBLIC = "Public",
  FEDERAL = "Federal",
}
